import axios from 'axios';

export default (product_id, product_name) => ({
    calculator: false,
    form: false,
    depth: 0,
    length: 0,
    width: 0,
    product_id: product_id,
    quantity: 1,
    postcode: '',
    grade: '',
    init() {
        let productNameField = document.querySelector('input[name="form-product-name"]');
        if (productNameField)
            productNameField.value = product_name;
    },
    calculateBags() {

        if (this.depth > 0 && this.length > 0 && this.width > 0) {
            var form_data = new FormData();
            form_data.append('product_id', this.product_id);
            form_data.append('depth', this.depth);
            form_data.append('length', this.length);
            form_data.append('width', this.width);

            axios.post(themosis.ajaxurl + '?action=bulk-bag-calculator', form_data, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content
                }
            }).then(response => {
                this.quantity = response.data;
                document.querySelector('input[name="calculator-bags"]').value = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        }

    },
    updateOrder() {
        document.querySelector('input[name="quantity"]').value = this.quantity;
        this.calculatePrice();
        this.calculator = false;
    },
    calculatePrice() {
        if (document.querySelector('select[name="grade"]') && document.querySelector('select[name="grade"]').length) {
            if (document.querySelector('select[name="grade"]').value != '') {
                document.querySelector('select[name="grade"]').parentElement.classList.remove('woocommerce-invalid');
            }
        }
        if (document.querySelector('input[name="postcode"]').value != '') {
            document.querySelector('input[name="postcode"]').parentElement.classList.remove('woocommerce-invalid');
        }

        if (this.quantity != '' && this.postcode != '') {
            var form_data = new FormData();
            form_data.append('product_id', this.product_id);
            form_data.append('quantity', this.quantity);
            form_data.append('postcode', this.postcode);
            form_data.append('grade', this.grade);

            axios.post(themosis.ajaxurl + '?action=price-calculator', form_data).then(response => {
                let productPrice = response.data.product_price;
                let shippingPrice = response.data.shipping_price;
                let vatRate = response.data.vat_rate;

                if (productPrice && shippingPrice && vatRate) {
                    let total = (+productPrice + +shippingPrice);
                    let totalWithVat = total + (total * (vatRate / 100));
                    document.getElementById('product_total_price').innerText = '£' + totalWithVat.toFixed(2);
                    document.getElementById('price_error').innerHTML = '';
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    addToBasket() {

        let errorMessage = '<strong>ERROR:</strong> Please enter the amount you require and a postcode above to proceed';

        let errors = false;
        if (document.querySelector('input[name="postcode"]').value == '' || document.querySelector('input[name="postcode"]').value == null) {
            document.querySelector('input[name="postcode"]').parentElement.classList.add('woocommerce-invalid');
            errors = true;
        }
        if (document.querySelector('select[name="grade"]') && document.querySelector('select[name="grade"]').length) {
            if (document.querySelector('select[name="grade"]').value == '' || document.querySelector('select[name="grade"]').value == null) {
                document.querySelector('select[name="grade"]').parentElement.classList.add('woocommerce-invalid');
                errors = true;
            }
        }

        if (errors) {
            document.getElementById('product_total_price').innerText = '';
            document.getElementById('price_error').innerHTML = errorMessage;
            return false;
        }

        var form_data = new FormData();
        form_data.append('product_id', this.product_id);
        form_data.append('grade', this.grade);
        form_data.append('quantity', this.quantity);
        form_data.append('delivery_postcode', document.querySelector('input[name="postcode"]').value);

        axios.post(themosis.ajaxurl + '?action=add-to-cart', form_data).then(response => {
            // redirect to cart page
            if(response.data.error) {
                document.getElementById('price_error').innerHTML = errorMessage;
            } else {
                window.location = response.data;
            }
            //window.location = response.data;
        }).catch(function (error) {
            console.log(error);
        });

    }
});
